module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/img_collaborate02-54d0458a0c3d0f5cfd3124cb46bf7ba4.png";